<script>
import NavBar from '@/components/NavBar.vue'
import LochlomondFooter from '@/components/footers/LochlomondFooter.vue'
import SestranFooter from '@/components/footers/SestranFooter.vue'

export default {
  components: {
    'nav-bar': NavBar,
    'lochlomond-footer': LochlomondFooter,
    'sestran-footer': SestranFooter,
  },
  data() {
    return {}
  },
}
</script>

<template>
  <div class="jpw">
    <nav-bar></nav-bar>

    <router-view></router-view>

    <lochlomond-footer v-if="$whitelabel.brand == 'lochlomond'"></lochlomond-footer>
    <sestran-footer v-if="$whitelabel.brand == 'sestran'"></sestran-footer>
  </div>
</template>
